<template>
    <!--  prop 'profile is required for this to work'  -->
    <v-dialog v-model="dialog"
              max-width="400"
              scrollable
    >

        <template v-slot:activator="{ on }">
            <v-btn icon  text v-on="on">
                <v-icon :color="color" >{{icons.dollar}}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Set Billing <v-spacer></v-spacer>
                <v-avatar><v-img :src="profile.info.profilepic" /> </v-avatar>
            </v-card-title>
            <v-card-text>
                <div v-if="!message">
                    Who is responsible for paying for {{profile.info.firstname}}?
                    <div v-if="payer">
                        Currently {{payer.name}} | {{payer.cell}} | {{payer.email}}
                    </div>
                    <v-text-field outlined small v-if="payer" v-model="payer.price" @change="changed=true" />
                </div>
                <div v-else class="font-weight-medium subtitle-1" >
                    {{message}}
                </div>

                <v-row  v-if="!message">
                    <v-col cols="12" class="pa-0">
                        <SearchContact @contact="confirmSelected($event)" :clear="dialog" />
                    </v-col>
                    <v-col cols="12" class="pa-0 pt-8">
                        <QuickAdd @newcontact="confirmSelected($event)"  />
                    </v-col>
                </v-row>

            </v-card-text>
            <v-card-actions>
                <v-btn text @click="Close()">cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn text v-if="changed" @click="setBilling">Save</v-btn>
                <v-btn text :disabled="!contact" @click="setBilling" :loading="loading" >Confirm</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import{
      mapState,
      mapActions
    } from 'vuex'
  import SearchContact from "@/views/contacts/SearchContact";
  import QuickAdd from "@/views/contacts/QuickAdd";
  export default {
    props:['profile','color'],
    name: "SetPlayerBilling",
    components: {QuickAdd, SearchContact},
    data(){
      return {
        dialog: false,
        contact: undefined,
        message: undefined,
        loading: false,
        changed:false
      }
    },
    mounted(){
      if(!this.profile.billing[this.org.partkey]){
        this.profile.billing[this.org.partkey]={}
      }
    },
    computed:{
      ...mapState(['icons','org']),
      profilepartkey(){
        return this.profile.partkey
      },
      payer(){
        return (this.profile.billing)?this.profile.billing[this.org.partkey]:{}
      }
    },
    watch:{
      dialog(n){
        if(!n)this.Close()
      }
    },
    methods:{
      ...mapActions(['get','post']),
      confirmSelected(e){
        this.contact=e
        this.message=' Set '+e.name+ ' ' + e.cell+' | ' + e.email + ' as payer for ' + this.profile.info.firstname+' ?'
      },
      async setBilling(){
        let data = {
          player: this.profile,
          contact: this.contact || this.payer,
          action:"add"
          //ie this will just overwrite any existing dat, for now.. just update blanks
        };
        this.loading=true
        let res = await this.post({path:'api/profilesv2/setbilling',body:data})
        this.loading=false
        this.Close()
      },
      Close(){
        this.dialog=false
        this.contact=undefined;
        this.message=false
      }
    }
  }
</script>

<style scoped>

</style>